import Vue from 'vue'

export var bus = new Vue({
    methods: {
        ShowDetailOrder(order1) {
            this.$emit('ShowDetailOrder', order1)
        },
        ShowOrder() {
            this.$emit('ShowOrder')
        },
        GetSkuOrder(response){
            this.$emit('GetSkuOrder', response)
        },
        ShowOrderReorder(data){
            this.$emit('ShowOrderReorder', data)
        },
        GetUsersByType(response) {
            this.$emit('GetUsersByType', response)
        },
        GetLogOrder(response) {
            this.$emit('GetLogOrder', response)
        },
        ShowOrderDespachador() {
            this.$emit('ShowOrderDespachador')
        },
        GetAllProduct(response) {
            this.$emit('GetAllProduct', response)
        },
        GetAllProductSku(response) {
            this.$emit('GetAllProductSku', response)
        },
        GetAllRestaurant(response) {
            this.$emit('GetAllRestaurant', response)
        },
        GetAllUser(response) {
            this.$emit('GetAllUser', response)
        },
        ResponseCreateOrder(response) {
            this.$emit('ResponseCreateOrder', response)
        },
        ResponseCreateOrderProduct(response) {
            this.$emit('ResponseCreateOrderProduct', response)
        },
        GetAllOrder(response, value) {
            this.$emit('GetAllOrder', response, value)
        },
        GetAllOrderSearch(response, value) {
            this.$emit('GetAllOrder', response, value)
        },
        GetAllOrderStatus(response) {
            this.$emit('GetAllOrderStatus', response)
        },
        GetAllOrderStatusBy(response) {
            this.$emit('GetAllOrderStatusBy', response)
        },
        ResponseUpdateOrderStatus(response) {
            this.$emit('ResponseUpdateOrderStatus', response)
        },
        ResponseUpdateOrderNew(response){
            this.$emit('ResponseUpdateOrderNew', response)
        },
        GetAllOrderPagination(response) {
            this.$emit('GetAllOrderPagination', response)
        },
        GetAllOrderPagination2(response) {
            this.$emit('GetAllOrderPagination2', response)
        },
        GetAllComprasDate(response) {
            this.$emit('GetAllComprasDate', response)
        },
        ShowUpdateMasivo(response) {
            this.$emit('ShowUpdateMasivo', response)
        },
        OrderStatusMAsivo(response) {
            this.$emit('OrderStatusMAsivo', response)
        },
        GetAllSCIDate(response) {
            this.$emit('GetAllSCIDate', response)
        },
        GetAllOrderUpdate(response) {
            this.$emit('GetAllOrderUpdate', response)
        },
        Buscador(response) {
            this.$emit('Buscador', response)
        },
        Missing(val){
            this.$emit('Missing', val)
        },
        GetAuditOrders(response){
            this.$emit('GetAuditOrders', response)
        }

    }
})
